export default "__VITE_ASSET__CRYybR9M__"